<div class="row">
  <div class="col-sm-12">
    <section class="panel">
      <app-page-title title="Edit Income" [loading]="isLoading"></app-page-title>

      <div class="panel-body">
        <form class="form-horizontal" (ngSubmit)="edit()" ngNativeValidate>
          <app-income-form [income]="income" *ngIf="income"></app-income-form>
        </form>
      </div>
    </section>
  </div>
</div>
